angular.module("app").directive("jsonGenerator", [
    "RecursionHelper",
    function (RecursionHelper) {
        return {
            restrict: "A",
            replace: true,
            templateUrl: "views/templates/jsonGenerator/tree.html",
            scope: {
                family: '=family'
            },
            compile: function (element) {

                return RecursionHelper.compile(element, function($scope, $element, $attrs, controller, transcludeFn){
                    $scope.addFamily = function (child) {
                        child.children.push(
                            {
                                key: "",
                                value: "",
                                children: []
                            }
                        );
                    };

                    $scope.removeFamily = function (parent, child) {
                        parent.children.splice(parent.children.indexOf(child), 1);
                    };
                });
            }
        }
    }
]).factory('RecursionHelper', ['$compile', function($compile){
    return {
        /**
         * Manually compiles the element, fixing the recursion loop.
         * @param element
         * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
         * @returns An object containing the linking functions.
         */
        compile: function(element, link){
            // Normalize the link parameter
            if(angular.isFunction(link)){
                link = { post: link };
            }

            // Break the recursion loop by removing the contents
            var contents = element.contents().remove();
            var compiledContents;
            return {
                pre: (link && link.pre) ? link.pre : null,
                /**
                 * Compiles and re-adds the contents
                 */
                post: function(scope, element){
                    // Compile the contents
                    if(!compiledContents){
                        compiledContents = $compile(contents);
                    }
                    // Re-add the compiled contents to the element
                    compiledContents(scope, function(clone){
                        element.append(clone);
                    });

                    // Call the post-linking function, if any
                    if(link && link.post){
                        link.post.apply(null, arguments);
                    }
                }
            };
        }
    };
}]);